export default "__VITE_ASSET__aLbc6$1h__"